<div class="toast-stack" aria-live="polite" aria-relevant="additions">
  @for (toast of toasts(); track toast.id) {
    <div
      class="toast"
      [class.toast--error]="toast.severity === 'error'"
      [class.toast--warning]="toast.severity === 'warning'"
      [class.toast--success]="toast.severity === 'success'"
      [class.toast--info]="toast.severity === 'info'"
      role="alert"
    >
      <span class="toast__icon" aria-hidden="true">
        @switch (toast.severity) {
          @case ('error') { ✕ }
          @case ('warning') { ! }
          @case ('success') { ✓ }
          @default { i }
        }
      </span>

      <div class="toast__body">
        <p class="toast__summary">{{ toast.summary || defaultSummary(toast.severity) }}</p>
        <p class="toast__detail">{{ toast.detail }}</p>
      </div>

      <button
        type="button"
        class="toast__close"
        aria-label="Dismiss notification"
        (click)="dismiss(toast.id)"
      >
        ✕
      </button>
    </div>
  }
</div>
